export default __webpack_public_path__ + "static/media/kedarnath2.a2f92e57.jpg";